module.exports = __webpack_public_path__ + "img/right-circle.027ed065.svg";